import React from "react";
import styled from "styled-components";

const SquareButton = styled.div`
    padding: 2rem;
    border: 2px solid #bbb;
    text-align: center;
    transition: border ease 0.3s;

    :hover {
        border: 2px solid #666;
        cursor: pointer;
    }
`;

export default SquareButton;
